/**
 * Script pour déplacer les éléments h3 entre les sections en fonction de la résolution de l'écran
 * Déplace les h3 de la section image_hero vers la section rich_text lorsque la résolution est inférieure à 768px
 * Les remet à leur place d'origine lorsque la résolution est supérieure à 768px
 */
document.addEventListener("DOMContentLoaded", function () {
  // Variables pour stocker l'état actuel
  let isMobile = window.innerWidth <= 768;
  let headingsMovedToTarget = false;

  // Fonction pour déplacer les éléments h3
  function moveHeadings() {
    // Récupérer les sections source et destination
    const sourceSection = document.getElementById(
      "shopify-section-template--25090203615580__image_hero_CJRzHh",
    );
    const targetSection = document.getElementById(
      "shopify-section-template--25090203615580__rich_text_JrnQXn",
    );

    // Vérifier si les sections existent
    if (!sourceSection || !targetSection) {
      return;
    }

    // Vérifier si nous sommes en mode mobile ou desktop
    const currentIsMobile = window.innerWidth <= 768;

    // Si l'état n'a pas changé, ne rien faire
    if (
      currentIsMobile === isMobile &&
      headingsMovedToTarget === currentIsMobile
    ) {
      return;
    }

    // Mettre à jour l'état
    isMobile = currentIsMobile;

    // Récupérer le conteneur original des headings
    const originalContainer = sourceSection.querySelector(
      ".image-hero__text-container",
    );
    if (!originalContainer) {
      return;
    }

    // Récupérer ou créer le conteneur dans la section cible
    let headingContainer = targetSection.querySelector(
      ".responsive-headings-container",
    );
    if (!headingContainer && isMobile) {
      headingContainer = document.createElement("div");
      headingContainer.className = "responsive-headings-container";
      targetSection.appendChild(headingContainer);
    }

    // Si nous sommes en mode mobile et que les headings n'ont pas encore été déplacés
    if (isMobile && !headingsMovedToTarget) {
      // Récupérer les éléments h3 de la section source
      const headings = sourceSection.querySelectorAll(
        ".image-hero__text-container-heading",
      );

      // Vérifier si les headings existent
      if (headings.length === 0) {
        return;
      }

      // Stocker la position originale des headings si ce n'est pas déjà fait
      if (!sourceSection.querySelector(".heading-placeholder")) {
        const placeholder = document.createElement("div");
        placeholder.className = "heading-placeholder";
        placeholder.style.display = "none";
        sourceSection.appendChild(placeholder);
      }

      // Déplacer les headings vers la section cible
      headings.forEach(function (heading) {
        headingContainer.appendChild(heading);
      });

      // Mettre à jour l'état
      headingsMovedToTarget = true;
    }
    // Si nous sommes en mode desktop et que les headings ont été déplacés
    else if (!isMobile && headingsMovedToTarget) {
      // Récupérer les headings déplacés
      const movedHeadings = targetSection.querySelectorAll(
        ".image-hero__text-container-heading",
      );

      // Remettre les headings à leur place d'origine
      movedHeadings.forEach(function (heading) {
        originalContainer.appendChild(heading);
      });

      // Supprimer le conteneur temporaire s'il existe
      if (headingContainer) {
        headingContainer.remove();
      }

      // Mettre à jour l'état
      headingsMovedToTarget = false;
    }
  }

  // Exécuter la fonction au chargement de la page
  moveHeadings();

  // Exécuter la fonction lors du redimensionnement de la fenêtre
  let resizeTimeout;
  window.addEventListener("resize", function () {
    // Utiliser un délai pour éviter d'exécuter la fonction trop souvent
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(moveHeadings, 250);
  });
});
